export default __webpack_public_path__ + "static/media/customLoader.ebbfc5ed.gif";